import React, { PropsWithChildren, useState } from 'react';
import Button, { ButtonProps } from 'components/DesignSystem/Button';
import ConfirmationDialogBox from 'components/ConfirmationDialogBox';
import { useClosure } from 'utils/hooks';

type ConfirmationButtonProps = PropsWithChildren<ButtonProps> & {
  confirmationBody: React.ReactNode;
};

export default function ConfirmationButton({
  confirmationBody,
  children,
  icon = undefined,
  submit = false,
  disabled = false,
  type = 'primary',
  small = false,
  iconPlacement = 'leading',
  className = '',
  id = undefined,
  title = '',
  onClick = () => {},
}: ConfirmationButtonProps) {
  const [confirmationOpen, setConfirmationOpen] = useState(false);

  return (
    <>
      <ConfirmationDialogBox
        open={confirmationOpen}
        dismiss={useClosure(setConfirmationOpen, false)}
        confirm={useClosure(onClick)}
      >
        {confirmationBody}
      </ConfirmationDialogBox>
      <Button
        icon={icon}
        submit={submit}
        disabled={disabled}
        type={type}
        small={small}
        iconPlacement={iconPlacement}
        className={className}
        id={id}
        title={title}
        onClick={useClosure(setConfirmationOpen, true)}
      >
        {children}
      </Button>
    </>
  );
}
